import { LinkButton } from "./LinkButton";

export function LanguageSwitcher({
  locales,
  locale,
  onChange,
}: {
  locales: string[];
  locale: string;
  onChange: (locale: string) => void;
}) {
  if (locales.length <= 1) return null;
  return (
    <div className="flex gap-3">
      {locales.map((l) => (
        <LinkButton key={l} active={l === locale} onClick={() => onChange(l)}>
          {l.toUpperCase()}
        </LinkButton>
      ))}
    </div>
  );
}
